import React from "react";

import { wrap } from "./RydTestbedWrap";
import {
    RydTrackInstrumentSelectionDialog,
    SoundfontInstrumentSelectionDialog,
    TrackOutputSelectionDialog,
    TrackOutputTypeIndicator,
    VirtualInstrumentSelectionDialog
} from "../components/dialogs/InstrumentSelectionDialog";
import {
    RydInstrument,
    RydInstrumentFactory,
} from "../model/instrument";
import { InstrumentName } from "soundfont-player";
import {
    TrackOutputType,
    TrackSourceType
} from "../model/tracks";
import {
    AudioSink,
    AudioSource,
    listAudioSources,
} from "../audio/routing";
import '../components/dialogs/InstrumentSelectionDialog.css';
import { MidiDeviceSelectionDialog } from "../components/midi/MidiDeviceSelectionDialog";
import { RydInputSource } from "../audio/input";
import {
    RydTrackSourceSelectionDialog,
    TrackSourceSelectionDialog
} from "../components/dialogs/SourceSelectionDialog";


export function InstrumentSelectionDialogTestbed() {
    const [sfInstrument, setSFInstrument] = React.useState<InstrumentName>();
    const [vInstrument, setVInstrument] = React.useState<RydInstrumentFactory>();
    const [trackOutputType, setTrackOutputType] = React.useState<TrackOutputType>();
    const [midiSink, setMidiSink] = React.useState<AudioSink>();
    const [rydInstrument, setRydInstrument] = React.useState<RydInstrument>();

    const [trackSourceType, setTrackSourceType] = React.useState<TrackSourceType>('MANUAL');
    const [midiSource, setMidiSource] = React.useState<AudioSource>();
    const [rydSource, setRydSource] = React.useState<RydInputSource>();

    return wrap(<>
        <h2>InstrumentSelectionDialog Testbed</h2>

        <ul>
            <li>SF instrument: {sfInstrument}</li>
            <li>V instrument: {vInstrument?.name}</li>
            <li>track: {trackOutputType}</li>
            <li>midiSource: {midiSink?.displayName} </li>
            <li>RydInstrument: {JSON.stringify(rydInstrument?.name)}</li>
        </ul>

        <table>
            <tbody>
                <tr>
                    <td>Soundfont instruments</td>
                    <td>
                        <SoundfontInstrumentSelectionDialog
                            setInstrument={setSFInstrument}
                        />
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>Track instrument</td>
                    <td><TrackOutputSelectionDialog setTrackOutput={setTrackOutputType} /></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Virtual instrument</td>
                    <td><VirtualInstrumentSelectionDialog selected={vInstrument} setSelected={setVInstrument} /></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Test</td>
                    <td>
                        <RydTrackInstrumentSelectionDialog
                            trackInstrument={rydInstrument}
                            setTrackInstrument={setRydInstrument}
                        />
                    </td>
                    <td>
                        <TrackOutputTypeIndicator output={rydInstrument} />
                    </td>
                </tr>
            </tbody>
        </table>

        <h2>Source selection testbed</h2>
        <table>
            <tbody>
                <tr>
                    <td>Source type</td>
                    <td><TrackSourceSelectionDialog
                        trackSourceType={trackSourceType}
                        setTrackSourceType={setTrackSourceType} /></td>
                    <td>{trackSourceType}</td>
                </tr>
                <tr>
                    <td>Midi selection</td>
                    <td><MidiDeviceSelectionDialog<AudioSource>
                        listSource={listAudioSources}
                        selected={midiSource}
                        setCB={setMidiSource} /></td>
                    <td>{midiSource?.displayName}</td>
                </tr>
                <tr>
                    <td>Loop source selection</td>
                    <td>---</td>
                    <td>---</td>
                </tr>
                <tr>
                    <td>Test</td>
                    <td>
                        <RydTrackSourceSelectionDialog
                            source={rydSource}
                            setSourceCB={setRydSource}
                        />
                    </td>
                    <td>
                        {rydSource?.type}
                        <RydTrackSourceSelectionDialog
                            source={rydSource}
                            setSourceCB={() => { }}
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </>);
}
